module.exports = __webpack_public_path__ + "static/img/spiked-rebar_64.96c6d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spiked-rebar_64.png
// module id = wRRE
// module chunks = 0